<!-- 平台公告编辑页面 -->
<template>
    <div>
      <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading" >
        <!-- 导航栏 start -->
        <div class="header">
          <div class="back" @click="goLastPage()">返回</div>
          <div class="title">{{ isDisabled?'公告详情':'发布公告' }}</div>
        </div>
        <!-- 导航栏 end -->
        <!-- 公告内容 start -->
        <div class="import-title">
          <span class="cost-title-list-txt">公告内容</span>
        </div>
        <div class="customer-information">
          <!-- 公告类型 -->
          <div class="import-new-wrap">
          <div class="cols">
            <div class="col-itms">
              <div class="title"><span>*</span>公告类型</div>
              <el-select size="small" class="w300" :disabled="isDisabled" v-model="form.noticeType" placeholder="请选择">
                <el-option v-for="item in getCodeListByKey('平台公告类型')" :key="item.value" :label="item.text" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="col-itms" style="padding-left: 60px;">
                <div class="title">
                  <el-popover trigger="hover" width="260" placement="top-start">
                    <div>{{ '用于恋链中强提醒弹框中的公告标题，以及待办消息、微信消息中的标题展示。' }}</div>
                    <template slot="reference">
                      <i class="el-icon-question"></i>
                    </template>
                  </el-popover>
                  <span>*</span>公告标题</div>
                <!-- <el-input size="small" class="w240" maxlength="30"  placeholder="最多可输入30个字" v-model="form.noticeTitle"></el-input> -->
                <el-input
                class=" w300"
                type="input"
                maxlength="12"
                size="small"
                ref="noticeTitle"
                :disabled="isDisabled"
                show-word-limit
                placeholder="最多输入12个字"
                @focus="titleFocus"
                v-model="form.noticeTitle"
                ></el-input>
              </div>
          </div>
          </div>
          <!-- 公告标题 -->
          <!-- <div class="import-new-wrap">
              <div class="cols">
                <div class="col-itms">
                  <div class="title"><span>*</span>公告标题</div>
                  
                  <el-input
                  class=" w300"
                  type="input"
                  maxlength="12"
                  show-word-limit
                  placeholder="最多输入12个字"
                  v-model="form.noticeTitle"
                  ></el-input>
                </div>
                
              </div>
            </div> -->
          <!-- 发布对象 -->
          <div class="import-new-wrap">
            <div class="cols">
              <div class="col-itms">
                <div class="title">
                  <el-popover trigger="hover" width="270" placement="top-start">
                    <div>
                      发布或撤回已发布【所有服务人员】类型的公告后，需间隔一小时再发布同类型公告
                    </div>
                    <template slot="reference">
                      <i class="el-icon-question"></i>
                    </template>
                  </el-popover>
                  <span>*</span>发布对象
                </div>
                <div class="publish-table">
                  <div class="top">
                    <div class="title-tips">
                      <el-radio-group class="w300 content-left" :disabled="isDisabled" v-model="form.publishObjectType">
                        <el-radio label="1">所有服务人员</el-radio>
                        <el-radio label="2">指定人员</el-radio>
                      </el-radio-group>
                      
                      <span v-show="form.publishObjectType==='2'" class="select-department" :class="isDisabled?'grey':''"  @click="chooseDepartmentPerson(1)">
                        <i class="el-icon-circle-plus" ></i>
                        添加人员
                      </span>
                    </div>
                    
                    <div  v-show="form.publishObjectType==='2'">总人数：{{ notifyUserNum }}人</div>
                  </div>
                  <div class="w817">
                    <el-table
                      :data="tableData"
                      v-show="form.publishObjectType==='2'"
                      border
                      tooltip-effect="light"
                      stripe
                      >
                      <el-table-column label="序号" width="60" header-align="center" align="center">
                        <template slot-scope="scope">
                          {{ scope.$index + 1 }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="tenantName"
                        label="通知公司"
                        show-overflow-tooltip
                        header-align="left" align="left"
                        width="185">
                      </el-table-column>
                      <el-table-column
                        prop="objectName"
                        label="指定对象"
                        header-align="left" align="left"
                        min-width="380">
                      </el-table-column>
                      
                      <el-table-column v-if="!isDisabled" prop="bank" min-width="125" label="操作" header-align="left" align="left" >
                        <template slot-scope="scope">
                          <div>
                            <a
                              class="txt-color"
                              @click="delOrg(scope.$index,scope.row)"
                              > 删除 |</a>
                            <a class="txt-color" @click="chooseDepartmentPerson(2,scope.$index)"> 编辑</a>
                          
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <!-- 公告内容 -->
          <div class="import-new-wrap">
            <div class="cols">
              <div class="col-itms">
                <div class="title">
                  <el-popover trigger="hover" width="260" placement="top-start">
                  <div>{{ '用于恋链中公告详情页面的具体内容' }}</div>
                  <template slot="reference">
                    <i class="el-icon-question"></i>
                  </template>
                </el-popover>
                  <span>*</span>公告内容</div>
                <el-input
                class="w817"
                type="textarea"
                :rows="5"
                :disabled="isDisabled"
                maxlength="800"
                show-word-limit
                placeholder="请输入，最多800个字"
                v-model="form.noticeContent"
                ></el-input>
              </div>
              
            </div>
          </div>  
          <!-- 公告摘要 -->
          <div class="import-new-wrap">
            <div class="cols">
              <div class="col-itms">
                <div class="title">
                  <el-popover trigger="hover" width="260" placement="top-start">
                    <div>{{ '用于恋链中强提醒弹框中的提示语，以及待办消息、微信消息中的文案。' }}</div>
                    <template slot="reference">
                      <i class="el-icon-question"></i>
                    </template>
                  </el-popover>
                  <span> </span> 公告摘要
                </div>
                <el-input
                class="w817"
                type="textarea"
                :rows="3"
                :disabled="isDisabled"
                maxlength="50"
                show-word-limit
                placeholder="若不填写，移动端默认展示公告内容的前100个字"
                v-model="form.noticeDesc"
                ></el-input>
              </div>
              
            </div>
          </div> 
          <!-- 内容图片 -->
          <div class="import-new-wrap" >
            <div class="cols">
              <div class="col-itms">
                <div class="title">
                  <el-popover trigger="hover" width="260" placement="top-start">
                  <div>{{ '用于恋链中公告详情页面中的图片，固定放在文案的后面追加展示' }}</div>
                  <template slot="reference">
                    <i class="el-icon-question"></i>
                  </template>
                </el-popover>
                  <span> </span> 内容图片
                </div>
                <div >
                  <el-upload
                    class="upload-demo t-left"
                    action="#"
                    ref="createProjectII"
                    :disabled="isDisabled"
                    :file-list="posterPhotoAttach"
                    accept=".jpg,.png,.jpeg"
                    :auto-upload="true"
                    :http-request="changeMainFile"
                    :before-upload="beforeAvatarUpload"
                    :limit="5"
                    :on-exceed="handleExceed"
                  >
                  <div class="file-operate" slot="file" slot-scope="{ file }" style="display: none;">
                  </div>
                  <div class="import-btn-tips">
                      <el-button size="mini" class="btn-upload" icon="el-icon-my-import" type="importNew"
                        >点击上传</el-button
                      >
                      <div class="import-step-tip">支持上传jpg、jpeg、png文件</div>
                    </div>
                  </el-upload>
                  <!-- 图片拖拽 start -->
                  <Draggable v-model="posterPhotoAttach" :disabled="isDisabled" v-if="Array.isArray(posterPhotoAttach)" chosen-class="chosen" force-fallback="true" animation="1000" @start="draggableStart(posterPhotoAttach)" @sort="getSort">
                    <transition-group>
                      <div  class="reason-content nowrap-ellipsis" v-for="(file, reasonIndex) in posterPhotoAttach" :key="reasonIndex">
                        <!-- <span class="reason-content-item">{{ `${reasonIndex + 1}、${reasonItem}` }}</span> -->
                          <div class="drag-img">
                            <div class="file-name">{{ file.fileName }}</div>
                            <div class="file-preview" @click="onPreview(file)">查看</div>
                            <div  class="file-preview" @click="handleSubRemove(file)">删除</div>
                            <div class="file-preview" @click="onDownload(file)">下载</div>
                          </div>
                        </div>
                    </transition-group>
                  </Draggable>
                  <!-- 图片拖拽 start -->
                </div>
                
              </div>
            </div>
          </div>
        </div>
        <!-- 公告内容 end -->

         <!-- 公告要求 start-->
        <div class="import-title">
          <span class="cost-title-list-txt">公告要求</span>
        </div>
        <div class="customer-information">
          <!-- col-1 -->
          <div class="import-new-wrap">
            <div class="cols">
              <!-- 反馈要求 -->
              <div class="col-itms">
                <div class="title"><span>*</span>反馈要求</div>
                <el-radio-group class=" content-left w360" :disabled="isDisabled" v-model="form.feedbackRequest">
                  <el-radio label="1">阅读</el-radio>
                  <el-radio :disabled="fbDisabled" label="2">确认</el-radio>
                  <el-radio :disabled="fbDisabled" label="3">签字</el-radio>
                </el-radio-group>
              </div>
              
            </div>
          </div>
          <!-- col-2 发布时间 -->
          <div class="cols" style="align-items: flex-start">
            <!-- 发送方式  -->
            <!-- <div class="col-itms">
                <div class="title"><span>*</span>发送企微消息</div>
                <el-radio-group class="w300 content-left" v-model="form.sendType">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                  
                </el-radio-group>
              </div> -->
              <!-- 发送方式  -->
              <div class="col-itms">
                <div class="title"><span> </span>发送方式</div>
                
                <el-radio-group class="w360 content-left" :disabled="isDisabled" v-model="form.sendType" >
                  <el-radio @click.native.prevent="radioClick('1')" label="1">微信消息</el-radio>
                  <el-radio disabled  label="2">企微消息</el-radio>
                  <!-- @click.native.prevent="radioClick('2')" -->
                  
                </el-radio-group>

                <!-- <el-checkbox-group v-model="form.sendType" :max="1">
                    <el-checkbox label="Y">微信消息</el-checkbox>
                    <el-checkbox label="N">企微消息</el-checkbox>
                </el-checkbox-group> -->
              </div>
            <div class="col-itms">
              <div class="title"><span>*</span>发布时间</div>
              <div class="publish-time">
                <el-radio-group class=" content-left title-tips" :disabled="isDisabled" v-model="form.publishDateType">
                  <el-radio label="1">立即发布</el-radio>
                  <el-radio label="2">定时发布</el-radio>
                </el-radio-group>
                <el-date-picker
                  size="small"
                  style="margin-top: -10px;"
                  popper-class="date-picker"
                  v-show="form.publishDateType==='2'"
                  v-model="form.publishDate"
                  :disabled="isDisabled"
                  type="datetime"
                  :default-value="new Date()"
                  value-format="yyyy-MM-dd HH:mm"
                  format="yyyy-MM-dd HH:mm"
                  :picker-options="expireTimeOption"
                  placeholder="选择发布时间"
                  @change="dateChange(form.publishDate,1)">
                </el-date-picker>
                
            </div>
            </div>
          </div>
          <!-- col-3 -->
          <div class="import-new-wrap">
            <div class="cols">
              <!-- 登录后强提醒  -->
              <div class="col-itms">
                <div class="title ">
                  <el-popover trigger="hover" width="260" placement="top-start">
                    <div>{{ '用户每次登录恋链后则进行提醒，查看/确认/签字后不提醒' }}</div>
                    <template slot="reference">
                      <i class="el-icon-question"></i>
                    </template>
                  </el-popover>
                  <span>*</span>登录后强提醒</div>
                <el-radio-group class="content-left w360" :disabled="isDisabled" v-model="form.isStrongRemind">
                  <el-radio label="Y">是</el-radio>
                  <el-radio label="N">否</el-radio>
                </el-radio-group>
              </div>
              <!-- 强提醒有效期 -->
              <div class="col-itms" style="display: flex;flex-shrink: 0;" v-if="form.isStrongRemind==='Y'">
                <div class="title">
                  <el-popover trigger="hover" width="260" placement="top-start">
                    <div>{{ '用户登录恋链后的强提醒弹框的展示有效期，不在这个时间段内则不再弹框提醒' }}</div>
                    <template slot="reference">
                      <i class="el-icon-question"></i>
                    </template>
                  </el-popover>
                  
                    <span>{{ this.form.isStrongRemind==='Y'?'*':' ' }}</span>强提醒有效期</div>
                    <div class="strong-remind">
                      <el-date-picker
                        v-model="strongRemindTime"
                        type="datetimerange"
                        class="w298"
                        :disabled="isDisabled"
                        ref="saveDateInput"
                        size="small"
                        popper-class="date-picker"
                        @change="dateChange(strongRemindTime,2)"
                        @focus="dateFocus(strongRemindTime)"
                        value-format="yyyy-MM-dd HH:mm"
                        format="yyyy-MM-dd HH:mm"
                        :picker-options="strongTimeOption"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        >
                      </el-date-picker>
                      <div class="strong-remind-tips" v-if="showStrong">
                        <span style="color: red;">该时间段存在其他强提醒</span>
                      <!-- <span class="items" @click="preview(strongGuid)">查看冲突详情</span> -->
                      </div>
                    </div>
                  
                  
              </div>
              
            </div>
          </div>
          
          <!-- 按钮 start -->
          <div class="operte-btns" v-if="!isDisabled">
            <div class="btn cancel" @click="goLastPage()">取消</div>
    
            <div  class="btn submit" @click="saveReq">提交</div>
            <div  class="btn submit" @click="saveReq(1)">提交并预览</div>
          </div>
          <div class="operte-btns" v-else>
            <div  class="btn cancel" @click="goLastPage()">取消</div>
            <div  class="btn submit" @click="preview($route.query.guid)">预览公告详情</div>
          </div>
          <!-- 按钮 start -->
      
        </div>
        <!-- 公告要求 end-->
      </div>
    
      <!-- 选择部门人员 start -->
      <ChooseUser ref="chooseDepartment"  @onSelect="onDepartmentSelect"></ChooseUser>
      <!-- 选择部门人员 end -->
      <!-- 强提醒冲突 start -->
      <StrongTips   :taskDetail="taskDetail"  v-if="showStrongTips"  @close="showStrongTips = false;"></StrongTips>
      <!-- 强提醒冲突 end -->
    </div>
  </template>
  
  <script>
  import ChooseUser from './components/chooseUser';
  import { deepClone } from '@/api/portrait.js'
  import StrongTips from './components/strongTips.vue'; 
  import draggable from 'vuedraggable';
  export default {
    components: {
      ChooseUser,
      StrongTips,
      Draggable: draggable,
    },
    data() {
      return {
        checkArr:[],//拖拽数组
        notifyUserNum:0,//合计人数
        timeVisible:false,
        strongRemindTime:[],//强提醒时间
        sendTenantList: [],
        taskDetail:[],
        previewGuid: [],
        // checkList:[],//发送方式
        activeIcon: 0,
        chooseURL: null,
        fileName:'',
        fullscreenLoading: false,
        posterPhotoAttach: [],
        guid: '',
        isCopy:false,
        isDisabled:false,
        showStrongTips:false,
        showStrong:false,
        // publishObjectType:'',
        form: {
          guid:'',//系统唯一标识
          noticeTitle:'',//公告标题
          noticeType:'',//公告类型
          publishObjectType:'',//发布对象类型，1 所有人员；2 指定人员
          publishObjectList:[],//发布对象
          notifyUserNum:'',//发布人数
          noticeDesc:'',//公告简述
          noticeContent:'',//公告内容
          noticeUrl:[],	//内容图片，[{"fileName":"","path":""},{"fileName":"","path":""}]
          feedbackRequest:'',// 反馈要求
          isStrongRemind:'Y',// 是否强提醒
          strongRemindBeginTime:'',// 强提醒开始时间
          strongRemindEndTime:'',// 强提醒结束时间
          // sendType:[],// 发送方式，1 微信消息；2 恋链代办消息
          sendType:'',// 发送方式，1 微信消息；2 恋链代办消息
          publishDateType:'',// 发布日期类型，1 立即发布；2 定时发布
          publishDate:'',//发布日期
        },
        coverPhotoAttach: [],
        expireTimeOption:{
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        },//时间限制当天以前可选
        strongTimeOption:{
          // disabledDate:this.disabledDate
          // disabledDate(time) {
          //   this.disabledDate(time)
          // }
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        },//时间限制当天以前可选
        area: [],
        tableData:[],//发布对象的表格
        departmentList: [],//发布对象的数据
        areaData: [],
        delList: [],
        filterText: '',
        publishObj:{
          guid:'',//系统唯一标识
          platformNoticeGuid:'',//平台公告GUID，关联mf_platform_notice的guid
          publishObjectType:'',//人员数量类型，1 所有人员;2 指定人员)
          tenantGuid:'',//企业GUID
          tenantName:'',//企业名称
          organisationGuid:'',//组织GUID
          staffGuid:'',//人员唯一标识
          staffName:'',//人员名称
        },
        flag:true,
        isWatch:false,
        fbDisabled:false,//反馈要求的禁用
      };
    },
    watch: {
      
      filterText(val) {
        this.$refs.treeDep.filter(val);
      },
      'form.noticeType'(val){
        
        let arr=this.getCodeListByKey('平台公告类型')
        if(!!this.isWatch){
          this.isWatch=false
          return
        }
        arr.forEach(i=>{
          if(i.value===val &&!this.isWatch){
            this.form.noticeTitle= i.text
          }
        })
      },
      'form.publishObjectType'(val){
        if(val==='1'){//所有服务人员
          this.tableData=[]
          this.departmentList=[]
          this.getNumber()
        }
      },
      'form.publishDateType'(val){
        if(val==='1'){//立即发布
          this.form.publishDate=''
          
        }
        // this.disabledDate()
      },
      'form.isStrongRemind'(val){
        if(val==='N'){
          this.strongRemindTime=[]
        }
      },
      'form.sendType'(val){
        if(val==='2'){
          this.fbDisabled=true
          this.form.feedbackRequest='1'
        }else {
          this.fbDisabled=false
          
        }
      },
    },
    
    created() {
      let userInfo=JSON.parse(localStorage.userInfo)
      if(this.$route.query.guid){
        this.guid=this.$route.query.guid
        this.isCopy=this.$route.query.isCopy
        this.isDisabled=!!this.$route.query.isDisabled||false
        // this.getSendTenantList()
        this.getDetail();
      }
      
    },
    methods: {
      // 公告标题focus
      titleFocus(){
        if(!this.form.noticeType){
          this.$refs.noticeTitle.blur()
          this.$message.warning('请先选择公告类型')
        }
      },
      // 发送方式单选
      radioClick(flg){
        this.form.sendType=this.form.sendType===flg?'':flg
      },
      // 发布时间change
      dateChange(time,flg){
        let str=''
        let now= Date.now()
        if(flg===1){//发布时间
          str='定时发布时间需晚于当前时间，请调整'
        }else{//强提醒时间
          this.showStrong=false
          if(this.form.publishDateType==='1'){
            str='强提醒时间需晚于当前时间，请调整'
          }else{
            str='强提醒时间需晚于或等于公告发布时间，请调整'
            now= Date.parse(this.form.publishDate)
          }
          // time=time[0]
        }
        // let startAt = new Date(time) * 1000 /1000;

        // if(startAt < now) {
        //   if(flg===3 ){
        //     throw new Error('强提醒时间需晚于或等于公告发布时间，请调整');
        //   }else{
        //     this.$message.warning(str)
        //   }
        //   if(flg===1){
        //     this.form.publishDate= "";
        //   }else{
        //     this.strongRemindTime= [];
        //   }
        // }

      },
      // 强提醒focus
      dateFocus(date,flg){
        if(!this.strongRemindTime){
          this.strongRemindTime=[]
          
        }
        this.$forceUpdate()
        let that=this
        this.flag=!this.flag//解决focus触发两次的问题
        let dateRange=document.getElementsByClassName("el-date-range-picker")
        
        let time=this.$moment(Date.now()).format('YYYY-MM-DD HH:mm:ss')
        
        if (!this.form.publishDateType) {
          this.$refs.saveDateInput.blur()
          if(this.flag)this.$message.warning('请先选择发布时间')
          this.strongRemindTime=[]
          if(dateRange[0]) dateRange[0].style.display='none'
          return
          // return 
        }else if(this.form.publishDateType==='1'){
          if(this.strongRemindTime && this.strongRemindTime.length<1){
            let strongRemindTime=[time,time]
            this.strongRemindTime=strongRemindTime
            this.$forceUpdate()
          }
          this.strongTimeOption={
            disabledDate(time) {
              return time.getTime() < Date.now() - 8.64e7
            }
          }
          return
        }else if(this.form.publishDateType==='2'){
          if(!this.form.publishDate){
            this.$refs.saveDateInput.blur()
            if(this.flag)this.$message.warning('请先选择发布时间')
            this.strongRemindTime=[]
            if(dateRange[0]) dateRange[0].style.display='none'
            return
          }else{
            if(this.strongRemindTime && this.strongRemindTime.length<1){
            let strongRemindTime=[this.form.publishDate,this.form.publishDate]
            this.strongRemindTime=strongRemindTime
            this.$forceUpdate()
          }
          }
          this.dateChange(this.strongRemindTime,2)
          this.strongTimeOption={
            disabledDate(time) {
              // return time.getTime() < new Date(that.form.publishDate).getTime()
              return time.getTime() < Date.parse(that.form.publishDate)+1- 8.64e7
            }
          }
          this.$forceUpdate()
          
          return
        }
      },
      //预览
      preview(guid) {
        let userName = '13900000001';
        const userPwd = '666666';
        let previewUrl;
        let formUrl=`/subActivityApp/announcement?guid=${guid}&isPreview=1`
        previewUrl = `https://llscmtest.cs4pl.com/loginRoot?userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(formUrl)}`;
          if (location.href.indexOf('https://scm-operation-pre-test.cs4pl.com') > -1) { //uat
            userName = '13900001026';
            previewUrl = `https://fbt-pre-test.cs4pl.com/loginRoot?userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(formUrl)}`
          }
          if (location.href.indexOf('https://scm-operation.csyaoly.com') > -1) { //生产1
            userName = '13900001026';
            previewUrl = `https://llscm.csyaoly.com/loginRoot?userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(formUrl)}`
          }
          if (location.href.indexOf('https://scm-operation.cs4pl.com') > -1) { //生产2
            userName = '13900001026';
            previewUrl = `https://llscm-pre.cs4pl.com/loginRoot?userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(formUrl)}`
          }
          window.open(location.origin + '/previewPage?previewUrl=' + encodeURIComponent(previewUrl))
      },
      // 获取企业和服务商
      getSendTenantList() {
        let self = this;
        let query = {
          isService: true,
          tenantGuid: localStorage.guid,
        };
        self.api
          .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
          .then((res) => {
            if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
              self.sendTenantList = res.data.data;
              if (!self.$route.query.guid && self.sendTenantList.length === 1) {
                self.sendTenantName = self.sendTenantList[0].sendTenantName;
                self.sendTenantGuid = self.sendTenantList[0].sendTenantGuid;
                
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      // 选择人员弹框
      chooseDepartmentPerson(flg,index) {
        if(this.isDisabled)return;
        // index为编辑时的下标
        if(flg===1){//新增
          this.$refs.chooseDepartment.open([]);
        }else{
          // let departmentList = this.departmentList;
          let departmentList = this.departmentList[index];
          let personList = [];
          departmentList.forEach(i => {
            personList.push(i.guid);
          });
          let tenantGuid=departmentList[0].tenantGuid
          this.$refs.chooseDepartment.open(personList,tenantGuid,index);
        }
        
      },
      //获取人员部门名称
      getDepartmentName(list) {
        if (typeof list === 'string') {
          list = JSON.parse(list);
        }
        let personArr = [];
        let personTip = '';
        let departmentArr = [];
        let departmentTip = '';
        let personNum = 0;
        let departmentNum = 0;
        if (list && list.length > 0) {
          list.forEach(i => {
            if (i.nodeType === '2') {
              // 人员
              personArr.push(i.organisationName || i.name);
              personNum = personNum + 1;
            } else {
              // 部门
              departmentNum = departmentNum + 1;
              departmentArr.push(i.organisationName || i.name);
            }
          });
        }
        personTip =
          personArr.length > 1
            ? personArr.splice(0, 1).join('、') + `等${personNum}个人`
            : personArr.splice(0, 1).join('、');
        departmentTip =
          departmentArr.length > 1
            ? departmentArr.splice(0, 1).join('、') + `等${departmentNum}个部门`
            : departmentArr.splice(0, 1).join('、');
        return departmentTip + (departmentTip && personTip ? '，' : '') + personTip;
      },
      //提交所选部门
      onDepartmentSelect([personGuidList, departmentData,index]) {
        if(departmentData.length<=0)return
        let departmentList = [];
        departmentData.forEach(item => {
          departmentList.push({
            organisationName: item.name,
            guid: item.guid,
            nodeType: item.nodeType,
            tenantGuid: item.tenantGuid,
            tenantName: item.tenantName,
          })
        })
        
        // let tenantName=JSON.parse(localStorage.userInfo).tenantName
        this.departmentList.forEach((item,idx)=>{
          if(item[0].tenantGuid===departmentList[0].tenantGuid){
            index=idx
            return
          }
            return 
        })
          
        if(index ||index===0 ){
          this.departmentList[index]=(departmentList);
          let str={
            tenantName:departmentData[0].tenantName,
            // ?departmentData[0].tenantName:tenantName
            objectName:this.getDepartmentName(departmentList)
          }
          this.$set(this.tableData,index,str)
        }else{
          this.departmentList.push(departmentList);
          this.tableData.push({
            tenantName:departmentData[0].tenantName?departmentData[0].tenantName:tenantName,
            objectName:this.getDepartmentName(departmentList)
          })
        }
        this.getNumber()
        let str=this.getDepartmentName(departmentList)
        this.$forceUpdate()
        // this.fullscreenLoading = true;
        
      },
      // 数据转换成树状
      treeData(areaData) {
        var self = this;
        const fn = (tree) => {
          tree.forEach(async (k) => {
            // 根据id获取人员数据,(注意转为树类型)
            if (k) {
              const isValid = (val) => {
                return val && val !== null && JSON.stringify(val) !== '[]';
              };
              // 将人员数据拼接到chilren里面
              if (k.children) {
                fn(k.children);
                k.children = [...k.children];
                // 有子元素，需要调用自身
              }
            }
          });
        };
        fn(areaData);
      },
      // 获取详情
      getDetail() {
        let that = this;
        let userInfo = JSON.parse(localStorage.userInfo);
        this.isWatch=true
        that.api.get(`/${serverConfig.msConfigureService}/platformNotice/detail?guid=${that.guid}&staffGuid=${userInfo.staffGuid}`).then((res) => {        
          if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE && res.data.data) {
            let form = res.data.data
            // form.coverUrl = form.coverUrl ? [JSON.parse(form.coverUrl)] : [];
            let noticeUrl=[]
            noticeUrl = form.noticeUrl ? JSON.parse(form.noticeUrl) : [];
            noticeUrl &&
            noticeUrl.forEach((item) => {
              this.posterPhotoAttach.push({
                fileName: item.fileName,
                path: item.path,
              });
            });
            let strongRemindTime=[]
            strongRemindTime=form.strongRemindBeginTime?[form.strongRemindBeginTime,form.strongRemindEndTime]:[]
            this.strongRemindTime=strongRemindTime
            this.notifyUserNum=form.notifyUserNum
            
            this.form={
              guid:form.guid,//系统唯一标识
              noticeType:form.noticeType,//公告类型
              noticeTitle:form.noticeTitle,//公告标题
              publishObjectType:form.publishObjectType,//发布对象类型，1 所有人员；2 指定人员
              publishObjectList:form.publishObjectList,//发布对象
              notifyUserNum:form.notifyUserNum,//总人数
              noticeDesc:form.noticeDesc,//公告简述
              noticeContent:form.noticeContent,//公告内容
              noticeUrl:form.noticeUrl,	//内容图片，[{"fileName":"","path":""},{"fileName":"","path":""}]
              feedbackRequest:form.feedbackRequest,// 反馈要求
              isStrongRemind:form.isStrongRemind,// 是否强提醒
              strongRemindBeginTime:form.strongRemindBeginTime,// 强提醒开始时间
              strongRemindEndTime:form.strongRemindEndTime,// 强提醒结束时间
              sendType:form.sendType,// 发送方式，1 微信消息；2 恋链代办消息
              publishDateType:form.publishDateType,// 发布日期类型，1 立即发布；2 定时发布
              publishDate:form.publishDate,//发布日期
            }
            //指定人员
            if (form.publishObjectList &&form.publishObjectList.length>0) {         
              var publishObjectList = form.publishObjectList;
              let result =this.groupArrayByProperty(publishObjectList, 'tenantGuid');  
                 
              let list=[]
              if(result.length>1){
                let arr=[]
                let arr1=[]
                result.forEach(item=>{
                  arr1=this.detailToTable(item,1)
                  arr.push(arr1)
                })
                list.push(arr)
                list=list.flat()
              }else{
                let arr=[]
                arr=this.detailToTable(result.flat(),1)
                list.push(arr)
              }    
              
              this.getNumber()      
            }
            if(this.isCopy){
              // 复制的时候清空发布时间
              this.form.publishDateType=''// 发布日期类型，1 立即发布；2 定时发布
              this.form.publishDate=''//发布日期
              this.form.guid=''
              this.strongRemindTime=[]
            }
          } else {
            that.$message.error(res.data.msg);
          }
          
        });
        
      },
      // 获取强提醒列表
      getStrongList(guid) {
        let self = this;
        let req= {
          pageIndex: 1,
          pageSize: -1,
          guids:guid
        };
        self.api.postJson(`/${serverConfig.msConfigureService}/platformNotice/list`, req).then((res) => {
          
          if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
            self.taskDetail = res.data.data.records;
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      // 部门数据转成表格
      detailToTable(list,flg){
        // flg从详情进，且list长度大于1
        let departmentList = [];
        list.forEach((item) => {
          if(item.organisationGuid && item.organisationGuid.length>0){
            // 选的是部门
            departmentList.push({
              guid: item.organisationGuid,
              organisationName: item.organisationName||'',
              platGuid:item.guid||'',
              nodeType: '1',
              tenantGuid:item.tenantGuid||'',
              tenantName:item.tenantName||'',
            });

          }else if(item.staffGuid && item.staffGuid.length>0){
            // 选的是人员
            departmentList.push({
              guid: item.staffGuid,
              organisationName: item.staffName||'',
              platGuid:item.guid||'',
              nodeType: '2',
              tenantGuid:item.tenantGuid||'',
              tenantName:item.tenantName||'',
            });

          }
          
        }
          
        );
        this.departmentList.push(departmentList)
        if(!flg)this.getNumber()
        let tenantName=JSON.parse(localStorage.userInfo).tenantName
          this.tableData.push({
            tenantName:departmentList[0].tenantName?departmentList[0].tenantName:tenantName,
              objectName:this.getDepartmentName(departmentList)
            })
        return departmentList
      },
      // 获取发布对象总人数
      getNumber() {
        let self = this;
        let publishObjectList=[]
        if(this.form.publishObjectType==='2'){
          this.departmentList.flat().forEach(item=>{
            if(item.nodeType==='1'){
              // 部门
              publishObjectList.push({
                organisationGuid:item.guid,
                organisationName:item.organisationName,
                guid:item.platGuid||'',
                tenantGuid:item.tenantGuid,
                tenantName:item.tenantName,
              })
            }else if(item.nodeType==='2'){
              // 人员
              publishObjectList.push({
                staffGuid:item.guid,
                staffName:item.organisationName,
                guid:item.platGuid||'',
                tenantGuid:item.tenantGuid,
                tenantName:item.tenantName,
              })
            }
        })
        }
        if(this.form.publishObjectType==='2' && publishObjectList.length<1){
          self.notifyUserNum=0
          return
        }
        let req={
          publishObjectType:this.form.publishObjectType,
          publishObjectList,
        }
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msConfigureService}/platformNotice/get-staff-number`, req).then((res) => {
          self.fullscreenLoading = false;
          if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
            self.notifyUserNum = res.data.data;
            this.$forceUpdate()
          } 
        });
      },
      //删除单个公司
      delOrg(index,row) {
        if (this.isDisabled) return;
        this.tableData.splice(index, 1);
        this.departmentList.splice(index, 1);
        this.getNumber()
      },
      // 发布对象数据处理
      groupArrayByProperty(arr, property) {
        const grouped = {}; 
        for (const item of arr) {
          const key = item[property];
            if (!grouped[key]) {
              grouped[key] = []; 
            } 
            grouped[key].push(item); 
          } 
            return Object.values(grouped); 
      } ,
      //提交申请
      saveReq(type) {
        if (!this.checkForm()) {
          return;
        }
        let form = JSON.parse(JSON.stringify(this.form));
        if(form.isStrongRemind==='Y'){
          form.strongRemindBeginTime = this.strongRemindTime && this.strongRemindTime[0]
          ? this.$moment(this.strongRemindTime[0]).format('YYYY-MM-DD HH:mm')
          : '';
          form.strongRemindEndTime = this.strongRemindTime && this.strongRemindTime[1]
          ? this.$moment(this.strongRemindTime[1]).format('YYYY-MM-DD HH:mm')
          : '';
        }else{
          form.strongRemindBeginTime=''
          form.strongRemindEndTime=''
        }
        form.notifyUserNum=this.notifyUserNum
        let publishObjectList=[]
        if(form.publishObjectType==='2'){
          this.departmentList.flat().forEach(item=>{
            if(item.nodeType==='1'){
              // 部门
              publishObjectList.push({
                organisationGuid:item.guid,
                organisationName:item.organisationName,
                guid:item.platGuid||'',
                tenantGuid:item.tenantGuid,
                tenantName:item.tenantName,
              })
            }else if(item.nodeType==='2'){
              // 人员
              publishObjectList.push({
                staffGuid:item.guid,
                staffName:item.organisationName,
                guid:item.platGuid||'',
                tenantGuid:item.tenantGuid,
                tenantName:item.tenantName,
              })
            }
          })
        }
        form.publishObjectList=publishObjectList
        let posterPhotoAttach = []
        let reqUrl;
        let method=''
        let message=''
        this.posterPhotoAttach.forEach((item) => {
          posterPhotoAttach.push({
            fileName : item.fileName,
            path : item.path
          })
        });
        
      form.noticeUrl = posterPhotoAttach.length ? posterPhotoAttach : [];
        
        if (form.guid) {
          reqUrl = `/${serverConfig.msConfigureService}/platformNotice/update`;
          form.guid = this.guid;
          method='put'
          message='修改成功'
        } else {
          reqUrl = `/${serverConfig.msConfigureService}/platformNotice/add`;
          form.guid = null;
          method='postJson'
          message='新增成功'
        }
          
          this .$confirm(`确定给${this.notifyUserNum}人发送消息吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          this.fullscreenLoading = true;
          this.api[method](reqUrl, form).then((res) => {
            this.fullscreenLoading = false;
            
            if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
              if(res.data.data){
                if(res.data.msg==='success'){
                  // 新增成功
                  if(type===1){//预览
                    this.previewGuid=res.data.data[0]
                    this.preview(this.previewGuid);
                  }
                  this.goLastPage()
                }else{
                  // 说明强提醒冲突
                  let strongGuid=res.data.data
                  this.getStrongList(strongGuid)
                  this.showStrongTips=true
                  this.showStrong=true

                  // this.tipsInfo=res.data.msg
                  // this.$message.error(res.data.msg);
                }
                
              }else{
                // 修改的时候没有data
                if(type===1){//预览
                  this.previewGuid=form.guid
                  this.preview(this.previewGuid);
                }
                this.goLastPage()
                
              }
              
            } else {
              this.$message.error(res.data.msg);
            }
          });
        });
        
      },
    
      // 返回上一页
      goLastPage() {
        this.$router.push({
          path: '/platformAnnouncementList',
          
        });
      },
      
      // 上传文件
      changeMainFile(file) {
        let isLt5M = file.file.size / 1024 / 1024 < serverConfig.FILE_SIZE;
        if (!isLt5M) {
          this.$message.error(`上传文件大小不能超过${serverConfig.FILE_SIZE}MB`);
          this.$refs.createProject.clearFiles(); // 清除前端显示的文件列表
          return;
        }
        let formData = new FormData();
        formData.append('file', file.file);
        formData.append('fileName', file.file.name);
        this.fullscreenLoading = true;
        this.api
          .postImage(`/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`, formData)
          .then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
              this.posterPhotoAttach.push({
                fileName: file.file.name,
                path: res.data.data.data,
              });
              this.$message({
                message: '上传成功',
                type: 'success',
              });
            } else {
              this.$message.error('上传失败!');
            }
          })
          .catch(() => {
            this.$message('上传失败！');
          });
      },
     //上传图片前校验 
      async beforeAvatarUpload(file) {
        if (file.type) {
          if (!(file.type.indexOf('jpg') >-1 || file.type.indexOf('jpeg') >-1 || file.type.indexOf('png') >-1)) {
            this.$message.error('请上传图片格式' )
            return Promise.reject(false)
          }
        }
      },
      // 删除图片
      handleSubRemove(file) {
        if(this.isDisabled)return
        this.posterPhotoAttach.forEach((item, index) => {
          if (item.path === file.path) {
            this.posterPhotoAttach.splice(index, 1);
          }
        });
      },
      // 上传图片长度限制
      handleExceed(files, fileList) {
        this.fileList = [];
        this.$message.warning('当前限制选择5个文件');
      },
      // 查看图片
      onPreview(file) {
        var fileSuffix = file.fileName ? file.fileName.substring(file.fileName.lastIndexOf('.') + 1) : '';
        if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
          return window.open(file.path, file.fileName);
        }
        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
      },
      // 下载图片
      onDownload(file) {
        window.open(file.path + '?response-content-type=application/octet-stream');
      },
      // 表单校验
      checkForm() {
        if (!this.form.noticeType) {
          this.$message.error('公告类型不能为空');
          return false;
        }
        if (!this.form.noticeTitle) {
          this.$message.error('公告标题不能为空');
          return false;
        }
        if (!this.form.publishObjectType) {
          this.$message.error('发布对象不能为空');
          return false;
        }
        if (this.form.publishObjectType==='2') {
          try{
            if(!this.tableData.length){
              throw new Error('指定人员不能为空');
            }
          } catch (e) {
            this.$message.error(e.message);
            return;
          }
        }
        if (!this.form.noticeContent) {
          this.$message.error('公告内容不能为空');
          return false;
        }
        // if (!this.posterPhotoAttach.length) {
        //   this.$message.error('内容图片不能为空');
        //   return false;
        // }
        
        if (!this.form.feedbackRequest) {
          this.$message.error('反馈要求不能为空');
          return false;
        }
        if (!this.form.publishDateType) {
          this.$message.error('发布时间不能为空');
          return false;
        }
        if (this.form.publishDateType==='2') {
          
          this.dateChange(this.strongRemindTime,2)
          try{
            if(!this.form.publishDate){
              throw new Error('发布时间不能为空');
            }
          } catch (e) {
            this.$message.error(e.message);
            return;
          }
        }
        if (!this.form.isStrongRemind) {
          this.$message.error('是否强提醒不能为空');
          return false;
        }
        if (this.form.isStrongRemind==='Y') {
          this.dateChange(this.strongRemindTime,3)
          try{
            console.log('pp',this.strongRemindTime);
            
            if(!this.strongRemindTime || this.strongRemindTime.length<1){
              throw new Error('强提醒有效期不能为空');
            }
          } catch (e) {
            this.$message.error(e.message);
            return;
          }
        }
        // if (!this.form.sendType) {
        //   this.$message.error('发布方式不能为空');
        //   return false;
        // }
        
        
        return true;
      },
      // 拖拽开始
      draggableStart(arr) {
        this.checkArr = arr
      },
      // 获取排序
      getSort({ oldIndex, newIndex }) {
        const targetRow = this.checkArr.splice(oldIndex, 1)[0]; // 获取第一条数据
        this.checkArr.splice(newIndex, 0, targetRow);
        // 将数组进行深拷贝，置空后重新赋值给数组
        let newArr = this.checkArr.splice(0);
        this.checkArr = []; // 置空
        this.checkArr = newArr;
        this.posterPhotoAttach=deepClone(this.checkArr)
      },
      // 排序后提交的list
      getResList() {
        let arr = []
        this.reasonList.forEach(reasonCategory=>{
          reasonCategory.list.forEach(reasonItem=>{
            if (!arr.find(item=>item.guid === reasonItem.guid)) {
              arr.push(reasonItem)
            } 
          })
        })
        return arr
      },
     
    },
  };
  </script>
  
  <style lang="less" scoped>
  .strong-remind{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
  }
  .strong-remind-tips{
    margin-top: 5px;
    font-size: 12px;
    .items{
      color: #4FA1A4;
      text-decoration: underline;
      cursor: pointer;
      margin-left: 5px;
    }
  }
  .publish-table{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .top{
      width: 100%;
      display: flex;
      justify-content: space-between;
      
    }
    .title-tips{
        margin-bottom: 6px;
      }
    
  }
  .publish-time{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    .title-tips{
      width: 220px;
    }
    
  }
  
  .select-department {
    position: relative;
    color: #4FA1A4;
    // text-decoration: underline;
    cursor: pointer;
    margin-left: -70px !important;
    
  }
  .grey{
    color: #b2b2b2;
  }
  .reason-content{
    margin: 5px 0;
  }
  .drag-img{
    display: flex;
  }
  
  /deep/.el-input-number__decrease {
    display: none;
  }
  /deep/.el-textarea .el-input__count {
    font-size: 16px;
  }
  /deep/ .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }
  /deep/.el-input-number__increase {
    display: none;
  }
  /deep/.el-table--border {
    // display: none;
    border: 1px solid #EBEEF5;

    border-right: none;
  }
  /deep/ .el-input-number .el-input__inner {
    text-align: left;
    padding-left: 15px;
  }
  
  
  
  
  .header {
    background: #fff;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;
  }
  
  .header .back {
    background: #ffffff;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
  }
  
  .import-title {
    text-align: left;
    background: #fff;
    padding: 10px 16px;
    font-size: 16px;
    position: relative;
    margin-top: 4px;
  }
  
  .import-title.second {
    margin-top: 4px;
  }
  
  .header .title {
    text-align: center;
    flex: 1;
  }
  
  .customer-information {
    background: #fff;
    padding-bottom: 15px;
  }
  
  .customer-information .sub-title {
    text-align: left;
    font-size: 14px;
    line-height: 28px;
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
  }
  
  .sub-operate-add {
    color: #4fa1a4;
    margin-left: 14px;
    cursor: pointer;
  }
  
  .sub-operate-add2 {
    color: #4fa1a4;
    font-size: 14px;
    margin-left: 14px;
    cursor: pointer;
    position: absolute;
    right: 35px;
    top: 10px;
    text-align: center;
  }
  
  .sub-operate-del {
    font-size: 14px;
    color: #4fa1a4;
    cursor: pointer;
    text-align: center;
    margin: 0 20px;
  }
  
  .customer-information .cols {
    background: #fff;
    display: flex;
    padding: 4px 16px;
    padding-left: 20px;
    align-items: baseline;
  }
  .w360{
    width:360px
  }
  .customer-information .col-itms {
    display: flex;
    align-items: baseline;
    margin-left: 20px;
  }
  
  .customer-information .col-itms .title {
    width: 120px;
    text-align: right;
    margin-right: 16px;
  }
  
  .customer-information .col-itms.second {
    margin-left: 170px;
  }
  
  .customer-information .col-itms .title span {
    color: red;
    .el-icon-question{
      color: #b2b2b2;
    }
  }
  
  .import-new-wrap {
    padding-bottom: 15px;
  }
  
  .import-new-wrap .import-step-tip {
    text-align: left;
    padding-left: 10px;
    color: #666;
    font-size: 12px;
  }
  
  .import-new-wrap .col-itms {
    align-items: baseline;
  }
  
  .operte-btns {
    background: #fff;
    margin-top: 2px;
    display: flex;
    justify-content: center;
    padding: 25px 0;
  }
  
  .operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;
    margin-right: 10px;
  }
  
  .operte-btns .btn.save {
    border: 1px solid #4FA1A4;
    color: #4FA1A4;
    cursor: pointer;
  }
  
  .operte-btns .btn.submit {
    border: 1px solid #4FA1A4;
    background: #4FA1A4;
    color: #fff;
    cursor: pointer;
  }
  .file-operate {
    display: flex;
    margin-top: 5px;
  }
  .file-preview {
    margin-left: 10px;
    cursor: pointer;
    text-decoration: underline;
    cursor: pointer;
    color: #4fa1a4;
  }
  .bank-content {
    text-align: left;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.1285, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.1285, 0.045, 0.355, 1);
  }
  .bank-info {
    color: #a7a7a7;
  }
  
  .content-left {
    text-align: left;
  }
  .btn-upload {
    width: 84px;
    height: 28px;
    padding: 0;
  }
  .icon-dialog {
  display: flex;
  overflow: hidden;
}

.icon-dialog .icon-left {
  width: 180px;
  text-align: left;
  border-right: 1px solid #cccc;
}

.icon-left .item {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 20px;
  
}

.icon-dialog .icon-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding-left: 10px;
}

.icon-right .pic {
  width: 100px;
  height: 130px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.icon-right .pic .img {
  width: 100px;
  height: 100px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.06);
}

.icon-right .pic .img:hover {
  border: 1px solid #4fa1a4;
  border-radius: 4px;
}

.img-wrap {
  position: relative;
}

.img-wrap .border-img {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 0;
  top: 0;
}

.img-wrap .name {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-img {
  width: 100%;
  height: 100%;
}

.icon-add {
  float: left;
  margin-left: 10px;
  width: 80px;
  height: 80px;
  border: 1px dotted #ccc;
  text-align: center;
  line-height: 80px;
}

.img-close {
  position: relative;
  float: left;
  width: 80px;
  height: 80px;
  margin-left: 20px;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
}
/deep/.el-table .cell{
    white-space: nowrap;
  }
  </style>
  <style>
  .cols-content{
      
      .el-textarea{
        width:840px
      }
    }
  .icon-dialog-wrap .el-dialog__body {
    padding: 0;
    padding-top: 10px;
  }
  #template-config .el-dialog {
      /* height: 80vh; */
      overflow: auto;
  }
  #template-config .el-form-item__content{
    margin-left:15px !important;
    display: flex;
  }
  #template-config .el-form-item{
    align-items:flex-start;
  }
  #template-config .calc-type .el-form-item__label{
    line-height:15px;
  }
  
    .el-input__inner{
      padding: 0 8px;
    }
    .detail-class .el-table__row{
      height: 12px;
      line-height: 12px;
    }
    .el-collapse-item__header {
      padding-left: 15px;
    }
    
    .el-upload--picture-card {
      float: left;
      margin-right: 10px;
    }
    
    .circle-closesty {
      position: relative;
      top: -35px;
      margin-left: 112px;
      font-size: 20px;
      cursor: pointer;
    }
    
    .v-modal {
      z-index: 100 !important;
    }
    
    .select-box {
      overflow: hidden;
      margin: 0 0px 10px 30px;
    }
    
    .box-left {
      width: 40%;
      height: 350px;
      padding: 0 20px 20px 20px;
      border: 1px solid #bbb;
      box-sizing: border-box;
      overflow-y: auto;
    }
    
    .box-right {
      width: 57%;
      height: 350px;
      padding: 0 10px 20px 20px;
      border: 1px solid #bbb;
      box-sizing: border-box;
    }
    
    .field-radio {
      display: flex;
      align-items: center;
    }
    
    .field-radio .el-form-item__content {
      margin-left: 0 !important;
    }
    .el-form-item {
      margin-bottom: 18px;
    }
    
    .other-config {
      display: flex;
      font-size: 14px;
      padding-left: 50px;
      /* padding-top: 30px; */
    }
    
    .other-content {
      flex: 1;
    }
    
    .other-content-list {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
    
    .other-title {
      padding-right: 10px;
    }
    
    /* 报货配置 */
    .bh-config-box {
      display: flex;
      height: 40px;
      align-items: center;
      font-size: 14px;
      padding-left: 50px;
      padding-top: 10px;
    }
    
    .bh-config-title {
      margin-right: 10px;
    }
    
    /* 库存信息采集 */
    .kc-label {
      font-size: 12px;
      color: #86909c;
    }
    
    .kc-label span {
      color: #4fa1a4;
      cursor: pointer;
    }
    
    .kc-box {
      padding: 16px;
      box-sizing: border-box;
    }
    
    .kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item {
      color: #323232;
    }
    
    .kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
      color: #323232;
    }
    .el-tabs__item.is-active{
      color: #4fa1a4;
    }
    .kc-box .el-tabs__item {
      border-right: 1px solid #dcdfe6 !important;
    }
    
    .kc-tab-box {
      height: 340px;
      padding: 0 0 40px;
      font-size: 14px;
      overflow-y: auto;
      box-sizing: border-box;
    }
    
    .kc-tab-list {
      padding: 0 0 40px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #dcdcdc;
    }
    
    .kc-tab-list:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
    
    .kc-tab-label {
      display: flex;
      margin-top: 30px;
    }
    
    .label-left-name img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    
    .tab-label-left {
      width: 350px;
      display: flex;
      margin-right: 20px;
    }
    
    .label-left-name {
      width: 100px;
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      flex-shrink: 0;
    }
    
    .tab-label-right {
      display: flex;
      align-items: center;
      color: #c8c8c8;
    }
    
    .tab-label-add {
      color: #4fa1a4;
      cursor: pointer;
      margin-right: 10px;
    }
    
    .tab-label-del {
      color: #d0021b;
      cursor: pointer;
      margin: 0 10px;
    }
    
    .kc-tab-rules {
      display: flex;
      margin-top: 16px;
    }
    
    .kc-rules-center {
      display: flex;
      align-items: center;
    }
    
    .rules-center-input span {
      margin: 0 8px;
    }
    
    .kc-no-label {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .kc-no-label img {
      width: 213px;
      margin-right: 35px;
    }
    
    .no-label-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    
    .no-label-text h3 {
      font-size: 18px;
      color: #7f828f;
      text-align: left;
      font-weight: 500;
      margin: 0;
    }
    
    .no-label-text p {
      font-size: 14px;
      color: #7f828f;
      line-height: 20px;
      margin: 6px 0 13px;
      text-align: left;
    }
    
    .no-label-btn {
      width: 120px;
      height: 40px;
      line-height: 40px;
      border-radius: 2px;
      text-align: center;
      color: #4fa1a4;
      cursor: pointer;
      border: 1px solid #4fa1a4;
    }
    
    .dy-table {
      width: 800px;
      margin-left: 10px;
    }
    
    .dy-table .dy-table-title {
      display: flex;
      height: 60px;
      line-height: 60px;
      background: #f2f2f2;
      border-bottom: 1px solid #ddd;
    }
    
    .dy-table .dy-table-title div {
      width: 200px;
    }
    
    .dy-table .dy-table-item {
      display: flex;
      height: 50px;
      align-items: center;
      border-bottom: 1px solid #ddd;
    }
    
    .dy-table-item-label {
      width: 200px;
      flex-shrink: 0;
      text-align: center;
    }
    
    .dy-table .dy-radio-box {
      width: 200px !important;
      text-align: center;
    }
    
    .dy-config-wrap {
      display: flex;
      font-size: 14px;
      margin: 30px 0;
      padding-left: 50px;
    }
    
    .dy-config-title {
      flex-shrink: 0;
      margin-top: 20px;
    }
    
    .product-select-all {
      margin-bottom: 20px;
    }
    .title-content {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      width: 100%;
    }
    .title-item {
      vertical-align: middle;
      text-align: center;
      padding-right: 10px;
    }
    .left-text {
      text-align: left;
    }
    
    .w100 {
      width: 100px;
    }
    .w160 {
      width: 160px;
    }
    .w200 {
      width: 30%;
    }
    .w240 {
      width: 200px;
    }
    .w640{
      width:640px
    }
    .w817{
      width:813px
    }
    .w298{
      width: 298px!important;
    }
    
    .configure-fields {
      width: 760px !important;
    }
    .configure-fields .el-dialog__body {
      overflow-y: auto;
      max-height: 600px;
    }
    .el-dialog__footer {
      border-top: 1px solid #d9d9d9;
    }
    .el-dialog__header {
      border-bottom: 1px solid #d9d9d9;
    }
    /* 选项内容样式 */
    .select-content-box {
      width: 92%;
      margin: 0 0px 10px 30px;
    }
    .select-content {
      width: 100%;
      /* padding:0 10px; */
      background: #fafafa;
      border: 1px solid #e5e5e5;
    }
    .el-form-item__label {
      color: #666;
    }
    .select-content .el-form-item__label {
      width: 90px !important;
    }
    .select-content .el-form-item__content {
      margin-left: 90px !important;
    }
    .config-item .el-form-item__content {
      margin-left: 0px !important;
    }
    /*  */
    .max-value {
      position: relative;
      height: 40px;
    }
    .max-value .el-input-number--mini {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 104px;
    }
    .date-picker{
    margin-bottom: 10px;
  }
  .date-picker  .el-picker-panel__footer .is-plain{
      border: 1px solid #4FA1A4;
      background: #4FA1A4;
      color: #fff;
      cursor: pointer;
    }
  </style>
  
  